import React, { useMemo, useState } from 'react';
import { Text } from 'components/typography/Text';
import { FormattedMessage } from 'react-intl';
import { AddFeed } from 'components/brikks/Office/RSSFeed/components/AddFeed';
import { InnerModal } from 'components/modals/InnerModal';
import { useRSSFeeds } from 'services/rss-feeds/get-rss-feeds/hook';
import { FocusableElement } from 'components/FocusableElement';
import styles from './styles.module.scss';

export const AddFeedButton = () => {
  const { rssFeeds } = useRSSFeeds();
  const [isAddFeedModalOpened, setIsAddFeedModalOpened] = useState(false);

  const customFeedsCount = useMemo(() => rssFeeds.filter(feed => !feed.default).length, [rssFeeds]);

  const maxCustomFeeds = 5;

  const openAddModal = () => {
    if (customFeedsCount < maxCustomFeeds) {
      setIsAddFeedModalOpened(true);
    }
  };

  return (
    <>
      <FocusableElement onClick={openAddModal}>
        <Text
          dark
          lightGray={customFeedsCount === maxCustomFeeds}
          clickable={customFeedsCount < maxCustomFeeds}
          small
        >
          <FormattedMessage id="addFeed" />
        </Text>
      </FocusableElement>

      <Text
        className={styles.grayText}
        small
      >
        {`${customFeedsCount}/${maxCustomFeeds} `}
        <FormattedMessage id="customFeeds" />
      </Text>
      <Text
        bold
        className={styles.addFeedDescription}
      >
        <FormattedMessage id="addFeedDescription" />
      </Text>

      <InnerModal
        isOpen={isAddFeedModalOpened}
        onClose={() => setIsAddFeedModalOpened(false)}
      >
        <AddFeed onAdd={() => setIsAddFeedModalOpened(false)} />
      </InnerModal>
    </>
  );
};
